import React, { useState } from 'react';
import moment from 'moment';
import CollapsiblePanel from '../../../../formInputsV2/CollapsiblePanel';
import { Card, AlwaysOpenAtDesktop } from './shared.styles';
import {
  Header, Title, ModificaButton, CompactSummary, InfoList, InfoRow,
} from './VehicleSummaryCard.styles';
import editIcon from '../../../../../assets/redesign_icons/edit-icon.svg';

function VehicleSummaryCard({ insuranceRequest, modificaDati }) {
  const [detailsOpen, setDetailsOpen] = useState(false);
  const { vehicle, customer } = insuranceRequest;

  const contraente = customer.gender !== 'G'
    ? `${customer.name} ${customer.surname}`
    : customer.business_name;

  const hasValue = Number(vehicle.value) > 0;

  const productLabel = insuranceRequest.product_id == 1 ? 'Auto' : 'Autocarro';

  return (
    <Card>
      <Header>
        <Title>
          {productLabel}
          {' '}
          <b>{vehicle.vehicle_plate}</b>
        </Title>
        {modificaDati && (
          <ModificaButton type="button" onClick={modificaDati}>
            Modifica Dati
            <img src={editIcon} alt="" />
          </ModificaButton>
        )}
      </Header>

      <CompactSummary>
        {vehicle.brand.name}
        {' '}
        {vehicle.version.description}
      </CompactSummary>

      <AlwaysOpenAtDesktop>
        <CollapsiblePanel
          open={detailsOpen}
          onToggle={() => setDetailsOpen((open) => !open)}
          instructionText=""
          openLabel="Nascondi dettagli"
          closedLabel="Dettagli veicolo"
        >
          <InfoList>
            <InfoRow>
              <dt>Contraente</dt>
              <dd>{contraente}</dd>
            </InfoRow>
            <InfoRow>
              <dt>Marca</dt>
              <dd>{vehicle.brand.name}</dd>
            </InfoRow>
            <InfoRow>
              <dt>Modello</dt>
              <dd>{vehicle.version.description}</dd>
            </InfoRow>
            <InfoRow>
              <dt>Targa</dt>
              <dd>{vehicle.vehicle_plate}</dd>
            </InfoRow>
            {hasValue && (
              <InfoRow>
                <dt>Valore Veicolo</dt>
                <dd>
                  {Number(vehicle.value).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  {' '}
                  €
                </dd>
              </InfoRow>
            )}
            <InfoRow>
              <dt>Inizio Copertura</dt>
              <dd>{moment(insuranceRequest.policy_effective_date).format('DD-MM-YYYY')}</dd>
            </InfoRow>
          </InfoList>
        </CollapsiblePanel>
      </AlwaysOpenAtDesktop>
    </Card>
  );
}

export default VehicleSummaryCard;
